import { useContext, type ReactNode } from 'react';
import { Navigate } from 'react-router';

import { ctxUser } from '@/contexts/UserContext';
import { reportError } from '@/integrations/sentry/errorReporting';

import type { ExtraFeature } from './extraFeatures';

type ExtraFeatureRouteGuardProps = {
  requiredExtraFeature: ExtraFeature;
  fallbackPath: string;
  children: ReactNode;
};

export function ExtraFeatureRouteGuard({ requiredExtraFeature, fallbackPath, children }: ExtraFeatureRouteGuardProps) {
  const userContext = useContext(ctxUser);

  if (!userContext) {
    reportError(new Error('ExtraFeatureRouteGuard rendered outside of ctxUser provider'), {
      feature: 'routing',
      requiredExtraFeature,
    });
    return <Navigate replace to={fallbackPath} />;
  }

  if (!userContext.hasExtraFeature(requiredExtraFeature)) {
    return <Navigate replace to={fallbackPath} />;
  }

  return children;
}
